module.exports = __webpack_public_path__ + "static/media/lc.80bdadc2.svg";